import React, { useState } from 'react';
import { Navigation } from '../Navigation';
import { InvestorSurvey } from '../InvestorSurvey';
import { motion } from 'framer-motion';
export function InvestorSurveyPage() {
  const [showSurvey, setShowSurvey] = useState(true);
  return <div className="min-h-screen bg-gradient-to-br from-[#B5EAD7] to-[#C5F467]" data-id="element-987">
      <Navigation data-id="element-988" />

      {showSurvey && <InvestorSurvey onClose={() => setShowSurvey(false)} data-id="element-989" />}

      {!showSurvey && <div className="pt-24 pb-12 px-4" data-id="element-990">
          <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl mx-auto text-center" data-id="element-991">
            <div className="bg-white rounded-[16px] p-12 shadow-xl" data-id="element-992">
              <h1 className="text-[#1A3D3A] mb-4" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '48px',
            fontWeight: 500,
            lineHeight: 1.2
          }} data-id="element-993">
                Thank You for Your Time
              </h1>
              <p className="text-[#3D5654] mb-6" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '18px',
            lineHeight: 1.7
          }} data-id="element-994">
                Your experience evaluating teams and predicting outcomes is
                crucial to this research. Your insights help us understand which
                signals truly matter in cofounder relationships. This will
                benefit the entire founder ecosystem.
              </p>
              <p className="text-[#3D5654] mb-8" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '16px',
            lineHeight: 1.6
          }} data-id="element-995">
                Your progress has been automatically saved. You can return
                anytime to complete the survey where you left off.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-996">
                <button onClick={() => setShowSurvey(true)} className="px-8 py-3 bg-[#1A3D3A] text-white rounded-lg hover:opacity-90 transition-all" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '0.5px'
            }} data-id="element-997">
                  Resume Survey
                </button>
                <a href="/" className="px-8 py-3 bg-white border-2 border-[#1A3D3A] text-[#1A3D3A] rounded-lg hover:bg-[#F8FAF9] transition-all" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '0.5px'
            }} data-id="element-998">
                  Return Home
                </a>
              </div>

              <p className="text-[#3D5654] mt-8 text-sm" style={{
            fontFamily: "'DM Sans', sans-serif",
            opacity: 0.7
          }} data-id="element-999">
                Questions? Email us at{' '}
                <a href="mailto:info@cofounder.fit" className="text-[#1A3D3A] underline hover:opacity-70 transition-opacity" data-id="element-1000">
                  info@cofounder.fit
                </a>
              </p>
            </div>
          </motion.div>
        </div>}
    </div>;
}